module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.f52f17d0.xml";